module.exports = __webpack_public_path__ + "static/media/CENTER VENT.470ffaac.svg";